var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BoxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,16v20.5c0,3.584 2.916,6.5 6.5,6.5h19c3.584,0 6.5,-2.916 6.5,-6.5v-20.5zM28.5,25h-9c-0.829,0 -1.5,-0.672 -1.5,-1.5c0,-0.828 0.671,-1.5 1.5,-1.5h9c0.829,0 1.5,0.672 1.5,1.5c0,0.828 -0.671,1.5 -1.5,1.5zM39.5,14h-31c-1.378,0 -2.5,-1.121 -2.5,-2.5v-4c0,-1.379 1.122,-2.5 2.5,-2.5h31c1.378,0 2.5,1.121 2.5,2.5v4c0,1.379 -1.122,2.5 -2.5,2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BoxFilled);
export default __webpack_public_path__ + "static/media/icons8-box-filled.912f49e5371db636868b44c19dd03d9f.svg";
export { ForwardRef as ReactComponent };